import React, { useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import styles from "../styles/Sidebar.module.css";

const Sidebar = ({ menu, topMenus }) => {
  const [open, setOpen] = useState(true);
  const { menu: currentMenu, "*": submenu } = useParams();
  const navigate = useNavigate();

  const getFullPath = (submenuName) => {
    console.log(submenuName);

    const path = `/${currentMenu
      .toLowerCase()
      .replace(/\s+/g, "-")}/${submenuName
        ?.toLowerCase()
        .replace(/\s+/g, "-")}`;
    navigate(path);
  };

  return (
    <>
      {menu?.isLeftMenu && (
        <div className={styles.sidebar}>
          <div className={styles.header}>
            <div className={styles.menuName}>
              <div className={styles.menuIcons}>
                {menu?.icon}
                {/* <img src={menu?.icon} alt={menu?.menu} /> */}
              </div>
              <span className={styles.name}>{menu?.menu}</span>
            </div>
          </div>
          <div className={styles.submenus}>
            {menu?.submenus.map((submenuItem) => (
              <div
                key={submenuItem.name}
                className={`${styles.submenuItem} ${submenu === submenuItem.route ? styles.selected : ""
                  }`}
                onClick={() => getFullPath(submenuItem.route)}
              >
                <div className={styles.subMenuName}>
                  <div className={styles.icons}>
                    {submenuItem?.icon}
                    {/* <img src={submenuItem?.icon} alt={submenuItem?.name} /> */}
                  </div>
                  <span
                    className={`${styles.name}
                  ${submenu === submenuItem.route ? styles.selected : ""}`}
                  >
                    {submenuItem.name}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default Sidebar;
